export const STEREOTYPE_LOAD = 'STEREOTYPE_LOAD'
export const STEREOTYPE_LOAD_COLUMNS = 'STEREOTYPE_LOAD_COLUMNS'
